import request from '@/utils/request'

export function add(data) {
  return request({
    url: '/role',
    method: 'post',
    data
  })
}

export function edit(data) {
  return request({
    url: '/role',
    method: 'put',
    data
  })
}

export function del(id) {
  return request({
    url: '/role',
    method: 'delete',
    data: [id]
  })
}

export function getRolePerms(params) {
  return request({
    url: '/role/perms',
    method: 'get',
    params
  })
}

export function editPermission(data) {
  return request({
    url: '/role/perms',
    method: 'put',
    data
  })
}

export function editUser(data) {
  return request({
    url: '/role/users',
    method: 'put',
    data
  })
}

export function delUser(data) {
  return request({
    url: '/role/users',
    method: 'delete',
    data
  })
}
